import { HttpClient } from '@adapters/HttpClient';
import type { BeepingTeamContacts, BeepingTeams } from '../../List/models/Clients';

export interface UpdateMarketingLangPayload {
    beepingTeams: BeepingTeams;
    beepingTeamContacts: BeepingTeamContacts[];
    marketingLang: 'ES' | 'EN';
}

export class ClientMarketingApiAdapter {
    constructor(private httpClient: HttpClient) {}

    async updateMarketingLang(teamId: number, payload: UpdateMarketingLangPayload): Promise<void> {
        const { beepingTeams, beepingTeamContacts, marketingLang } = payload;

        await this.httpClient.put(`/teams-child/${teamId}`, {
            beeping_teams: {
                ...beepingTeams,
                marketing_lang: marketingLang,
            },
            beeping_team_contacts: beepingTeamContacts,
        });
    }
}

